import { format as formatWhatsapp } from "@flasd/whatsapp-formatting";

export function anchorText(fullText) {
  const text = fullText;

  const exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=$~_|!:,.;]*[-A-Z0-9+&@#\/%=$~_|])/gi;
  const text1 = text.replace(exp, "<a target='_blank' href='$1'>$1</a>");
  const exp2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;

  return text1.replace(exp2, '$1<a target="_blank" href="http://$2">$2</a>');
}

export function convertBreakLines(fullText) {
  return fullText
    .replace(/(?:\r\n|\r|\n)/g, "<br/>")
    .replace(/&lt;br&gt;/g, "<br/>");
}

export function traitText(fullText) {
  const textWithBRTags = convertBreakLines(fullText);
  const text = anchorText(textWithBRTags);

  return formatWhatsapp(text);
}

export function removeTags(fullText) {
  return fullText.replace(/<\/?[^>]+(>|$)/g, "");
}

export function cleanText(fullText) {
  const text = formatWhatsapp(fullText);

  return removeTags(text);
}
